const buildIdFromString = (name: string | number) => {
    return `${name}`
        .trim()
        .toLowerCase()
        .replace(/\s/g, '-')
}

export default buildIdFromString